@if (locationsLoading() || yearsLoading()) {
  <app-supplier-contracts-filter-form-skeleton />
} @else {
  <form (submit.prevent)="onChangeFilter()" class="block @container">
    <div class="flex flex-col @3xl:flex-row gap-x-3 gap-y-5 items-start @3xl:items-center">
      <div class="flex-1 flex gap-3 items-center w-full">
        <ui-switch-bar
          class="hidden @3xl:inline-block w-[78px]"
          [formField]="filterForm.view"
          (fieldValueChange)="onChangeFilter()"
        >
          <ui-switch-bar-option
            value="grid"
            [uiTooltip]="'cockpit.supplierContracts.page.gridViewTitle' | transloco"
          >
            <ng-icon name="heroSquares2x2" size="20" class="!block" />
          </ui-switch-bar-option>
          <ui-switch-bar-option
            value="table"
            [uiTooltip]="'cockpit.supplierContracts.page.tableViewTitle' | transloco"
          >
            <ng-icon name="heroListBullet" size="20" class="!block" />
          </ui-switch-bar-option>
        </ui-switch-bar>

        <div class="flex-1 grid grid-cols-1 @3xl:grid-cols-3 gap-3 items-center">
          <ui-select
            [attr.aria-label]="'cockpit.supplierContracts.page.yearFilterLabel' | transloco"
            [formField]="filterForm.data.year"
            (selectChange)="onChangeFilter()"
          >
            @for (year of years(); track year) {
              <option [value]="year" [selected]="+filterForm.data.year().value() === year">
                {{ year }}
              </option>
            }
          </ui-select>

          <ui-select
            class="hidden @3xl:inline"
            [attr.aria-label]="'cockpit.supplierContracts.page.utilityTypeFilter.both' | transloco"
            [formField]="filterForm.data.utilityType"
            (selectChange)="onChangeFilter()"
          >
            <option [selected]="filterForm.data.utilityType().value() === 'ALL'" value="ALL">
              {{ 'cockpit.supplierContracts.page.utilityTypeFilter.both' | transloco }}
            </option>
            <option
              [selected]="filterForm.data.utilityType().value() === 'ELECTRICITY'"
              [value]="'ELECTRICITY'"
            >
              {{ 'cockpit.supplierContracts.page.utilityTypeFilter.electricity' | transloco }}
            </option>
            <option [selected]="filterForm.data.utilityType().value() === 'GAS'" [value]="'GAS'">
              {{ 'cockpit.supplierContracts.page.utilityTypeFilter.gas' | transloco }}
            </option>
          </ui-select>

          @if (locationsLoading()) {
            <ui-skeleton class="hidden @3xl:block h-10 rounded-md" />
          } @else {
            <ui-select
              class="hidden @3xl:inline"
              [attr.aria-label]="'cockpit.supplierContracts.page.allLocationsFilter' | transloco"
              (selectChange)="onChangeFilter()"
              [formField]="filterForm.data.locationID"
            >
              <option selected value="">
                {{ 'cockpit.supplierContracts.page.allLocationsFilter' | transloco }}
              </option>
              @for (location of locations(); track location.id) {
                <option [value]="location.id">{{ location.data | formatLocationName }}</option>
              }
            </ui-select>
          }
        </div>

        <ui-button
          class="inline @3xl:hidden"
          mode="outlined"
          type="button"
          [iconOnly]="true"
          [attr.aria-label]="'cockpit.supplierContracts.page.moreFiltersButton' | transloco"
          (click)="mobileFilterDialog.showModal()"
        >
          <ng-icon name="heroFunnel" size="20" class="!block" />
        </ui-button>
      </div>
      <ui-toggle-label class="flex-none">
        <ui-toggle [formField]="filterForm.fullPrice" (checkedChange)="onChangeFilter()" />

        {{ 'cockpit.supplierContracts.page.pricesIncludingTaxes' | transloco }}
      </ui-toggle-label>
    </div>

    <ui-simple-dialog #mobileFilterDialog>
      <ui-simple-dialog-layout class="w-full" (clickCancel)="mobileFilterDialog.close()">
        <ng-container slot="title">
          {{ 'cockpit.supplierContracts.page.moreFiltersTitle' | transloco }}
        </ng-container>
        <div class="flex flex-col gap-6">
          <ui-select
            [attr.aria-label]="'cockpit.supplierContracts.page.yearFilterLabel' | transloco"
            [formField]="filterForm.data.year"
            (selectChange)="onChangeFilter()"
          >
            @for (year of years(); track year) {
              <option [value]="year" [selected]="+filterForm.data.year().value() === year">
                {{ year }}
              </option>
            }
          </ui-select>

          <ui-select
            [attr.aria-label]="'cockpit.supplierContracts.page.utilityTypeFilter.both' | transloco"
            [formField]="filterForm.data.utilityType"
            (selectChange)="onChangeFilter()"
          >
            <option [selected]="filterForm.data.utilityType().value() === 'ALL'" value="ALL">
              {{ 'cockpit.supplierContracts.page.utilityTypeFilter.both' | transloco }}
            </option>
            <option
              [selected]="filterForm.data.utilityType().value() === 'ELECTRICITY'"
              [value]="'ELECTRICITY'"
            >
              {{ 'cockpit.supplierContracts.page.utilityTypeFilter.electricity' | transloco }}
            </option>
            <option [selected]="filterForm.data.utilityType().value() === 'GAS'" [value]="'GAS'">
              {{ 'cockpit.supplierContracts.page.utilityTypeFilter.gas' | transloco }}
            </option>
          </ui-select>

          @if (locationsLoading()) {
            <ui-skeleton class="block w-50 h-10 rounded-md" />
          } @else {
            <ui-select
              [attr.aria-label]="'cockpit.supplierContracts.page.allLocationsFilter' | transloco"
              (selectChange)="onChangeFilter()"
              [formField]="filterForm.data.locationID"
            >
              <option selected value="">
                {{ 'cockpit.supplierContracts.page.allLocationsFilter' | transloco }}
              </option>
              @for (location of locations(); track location.id) {
                <option [value]="location.id">{{ location.data | formatLocationName }}</option>
              }
            </ui-select>
          }
          <ui-toggle-label>
            <ui-toggle [formField]="filterForm.fullPrice" (checkedChange)="onChangeFilter()" />
            {{ 'cockpit.supplierContracts.page.pricesIncludingTaxes' | transloco }}
          </ui-toggle-label>
        </div>
      </ui-simple-dialog-layout>
    </ui-simple-dialog>
  </form>
}
